/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const ShareIcon = ({ color = '#FFF', className = null }) => (
    <svg
        width="39.58px"
        height="26.67px"
        viewBox="0 0 39.58 26.67"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path fill={color} d="M24,2.67v21.33H2.67V2.67h21.33M26.67,0H0v26.67h26.67V0h0Z" />
        <path
            fill={color}
            d="M39.58,9.68L29.91,0v4.9c-10.67,0-20.18,5.69-21.87,15.24h1.51c5.69-5.69,9.98-5.81,20.36-5.81v5.02l9.68-9.68Z"
        />
    </svg>
);

ShareIcon.propTypes = propTypes;

export default ShareIcon;
